import { getActiveMentionTrigger } from './getActiveMentionTrigger.js'



export function runSyncMentionUi(editor, enableMentions, refs) {
  const { mentionOpenRef, mentionRangeRef, setMentionTrigger, setMentionAnchor } = refs

  if (!editor || editor.isDestroyed || !enableMentions) {
    setMentionTrigger(null)
    setMentionAnchor(null)
    mentionOpenRef.current = false
    return
  }

  const trigger = getActiveMentionTrigger(editor)
  if (!trigger) {
    setMentionTrigger(null)
    setMentionAnchor(null)
    mentionRangeRef.current = null
    mentionOpenRef.current = false
    return
  }

  mentionRangeRef.current = trigger.range
  try {
    const coords = editor.view.coordsAtPos(trigger.range.from)
    setMentionTrigger((prev) =>
      prev?.query === trigger.query && prev?.range?.from === trigger.range.from ? prev : trigger,
    )
    setMentionAnchor((prev) => {
      const next = {
        getBoundingClientRect: () =>
          DOMRect.fromRect({
            x: coords.left,
            y: coords.top,
            width: 0,
            height: coords.bottom - coords.top,
          }),
      }
      const prevRect = prev?.getBoundingClientRect?.()
      if (
        prevRect &&
        prevRect.left === coords.left &&
        prevRect.top === coords.top &&
        prevRect.height === coords.bottom - coords.top
      ) {
        return prev
      }
      return next
    })
    mentionOpenRef.current = true
  } catch {
    setMentionTrigger(null)
    setMentionAnchor(null)
    mentionOpenRef.current = false
  }
}
